module.exports = __webpack_public_path__ + "img/8.f6c2a0e1.jpeg";